import styled from 'styled-components';
import { colorCSS } from '../../styles';
export const Arrow = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
  svg {
    fill: ${colorCSS('N20')};
    path {
      stroke: ${colorCSS('N100')};
    }
  }
  &:hover {
    svg path {
      stroke: ${colorCSS('T300')};
    }
  }
`;
//# sourceMappingURL=ArrowControls.styles.js.map